<template>
    <div class="domains py-3 px-4" v-if="domains && simulation && ratingOptions">
        <div>

            <el-popover placement="left">
                <i slot="reference" class="far fa-question-circle float-right"></i>
                <div class="pt-2 pr-2 pl-2 help">
                    <h3>{{ $t('dashboard.general-comment') }}</h3>
                    <p v-html="$t('overview.'+registration.degree.lang+'-global-feedback-help')"></p>
                </div>
            </el-popover>
            <h6 class="modal-title text-uppercase pb-3">
                {{ $t('dashboard.general-comment') }}
            </h6>

            <base-input class="mb-3">
                <textarea class="form-control" rows="8"
                    :placeholder="$t('overview.'+registration.degree.lang+'-your-comments')"
                    v-model="comment"
                ></textarea>
            </base-input>

        </div>
        <div v-for="domain in domains" :key="domain.id">

            <el-popover placement="left">
                <i slot="reference" class="far fa-question-circle float-right"></i>
                <div class="pt-2 pr-2 pl-2 help">
                    <h3>{{ domainName(domain) }}</h3>
                    <p v-html="domainDescription(domain)"></p>
                </div>
            </el-popover>
            <h6 class="modal-title text-uppercase pb-3">
                {{ domainName(domain) }}
            </h6>

            <rating-edit
                :options="ratingOptions"
                v-model="ratings[domain.id]"
            >
            </rating-edit>

            <base-input class="mb-3">
                <textarea class="form-control" rows="8"
                    :placeholder="$t('overview.'+registration.degree.lang+'-your-comments')"
                    v-model="comments[domain.id]"
                ></textarea>
            </base-input>

        </div>
    </div>
</template>

<script>
    import RatingEdit from './RatingEdit'

    export default {

        components: {
            RatingEdit
        },

        props: {

            simulation: {
                type: Object,
            },

            registration: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },

            domains: {
                type: Array,
            },
        },

        data() {
            return {
                ratings: null,
                comments: null,
                comment: null,
            }
        },

        watch: {

            simulation: {
                immediate: true,
                handler(simulation) {

                    this.ratings = this.domains.reduce((cumulated, domain) => {
                        cumulated[domain.id] = simulation.state.domains && simulation.state.domains[domain.id]
                            ? simulation.state.domains[domain.id]
                            : -1
                        return cumulated
                    }, {})

                    this.comments = this.domains.reduce((cumulated, domain) => {
                        cumulated[domain.id] = simulation.state.domain_comments && simulation.state.domain_comments[domain.id]
                            ? simulation.state.domain_comments[domain.id]
                            : null
                        return cumulated
                    }, {})

                    this.comment = simulation.state.comment
                }
            },

            ratings: {
                deep: true,
                immediate: true,
                handler(ratings) {
                    this.$emit('change', { ratings, comments: this.comments, comment: this.comment })
                }
            },

            comments: {
                deep: true,
                immediate: true,
                handler(comments) {
                    this.$emit('change', { ratings: this.ratings, comments, comment: this.comment })
                }
            },

            comment: {
                immediate: true,
                handler(comment) {
                    this.$emit('change', { ratings: this.ratings, comments: this.comments, comment })
                }
            }
        },

        methods: {

            domainName(domain) {
                const nameProp = 'name_' + this.registration.degree.lang
                return domain[nameProp]
            },

            domainDescription(domain) {
                const nameProp = 'description_' + this.registration.degree.lang
                return domain[nameProp]
            },
        }
    }
</script>

<style lang="css" scoped>

    .fa-question-circle {
        cursor: pointer;
        font-size: 1rem;
    }

</style>